<template>
  <div class="row__dropdown" ref="dropdown">
    <div class="row__dropdown-item row__dropdown-item--edit icon__edit" @click="onEdit()" ref="dropdownEdit">
      Edit
    </div>
    <div class="row__dropdown-item row__dropdown-item--taxes icon__taxes" @click="onTaxes()" ref="dropdownTaxes">
      Taxes
    </div>
    <div class="row__dropdown-item row__dropdown-item--delete icon__delete" @click="onDelete()" ref="dropdownDelete">
      Delete
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

defineOptions({
  name: "TeamsRowActionDropdown"
});

const { onEdit, onDelete, onTaxes } = defineProps({
  onEdit: {
    required: true,
    type: Function,
  },
  onDelete: {
    required: true,
    type: Function,
  },
  onTaxes: {
    required: true,
    type: Function,
  },
});

const emit = defineEmits(["toggleDropdown"]);

// Template refs
const dropdown = ref(null);
const dropdownEdit = ref(null);
const dropdownDelete = ref(null);

const checkIfClickedInside = (event) => {
  const { target } = event;

  // Checking if the click target is the container or specific children
  if (
    target === dropdown.value?.parentElement ||
    target === dropdownEdit.value ||
    target === dropdownDelete.value
  ) {
    emit("toggleDropdown", true);
  } else {
    emit("toggleDropdown", false);
  }
};

onMounted(() => {
  document.addEventListener("click", checkIfClickedInside);
});

onUnmounted(() => {
  document.removeEventListener("click", checkIfClickedInside);
});
</script>
<style></style>
